<div class="modal-container">
  <div class="data-container">
    <div class="data-container">
      <div class="field-wrapper" *ngIf="!minisiteDB; else editsite">
        <p class="text-start">Crear site</p>
        <div class="d-flex align-items-center">
          <span>https://3ddigitalvenue.com/</span><input type="text" placeholder="fcbarcelona" [(ngModel)]="client" />
          <button class="btn-secondary-action" (click)="checkIfExists()" *ngIf="sitealreadyExists">
            Comprobar URL de nuevo
          </button>
          <i class="fa fa-check ms-2" *ngIf="checkedSite && !sitealreadyExists"></i>
        </div>
      </div>
      <ng-template #editsite>
        <div class="field-wrapper">
          <p class="text-start">Editar site</p>
          <div class="d-flex align-items-center">
            <span>https://3ddigitalvenue.com/</span><span>{{ client }}</span>
            <button class="btn-secondary-action" (click)="checkIfExists()" *ngIf="sitealreadyExists">
              Comprobar URL de nuevo
            </button>
            <i class="fa fa-check ms-2" *ngIf="checkedSite && !sitealreadyExists"></i>
          </div>
        </div>
      </ng-template>

      <div class="selector-div-wrapper-sized">
        <div class="selector-div-wrapper align-items-center">
          <span>Publicar</span>
          <div class="selector-div">
            <select name="selector" class="selector" [(ngModel)]="enableSiteOnPublish">
              <option [ngValue]="true">Si</option>
              <option [ngValue]="false">No</option>
            </select>
            <div class="vertical-line"></div>
          </div>
        </div>
        <div class="selector-div-wrapper align-items-center">
          <span>Minisite de test</span>
          <div class="selector-div">
            <select name="selector" class="selector" [(ngModel)]="siteFlags.testMap">
              <option [ngValue]="true">Si</option>
              <option [ngValue]="false">No</option>
            </select>
            <div class="vertical-line"></div>
          </div>
        </div>
      </div>
      <div class="d-flex align-items-center mb-2 mt-2">
        <span>Recinto: </span><span class="ms-2 fw-bold">{{ venue?.name }}</span>
      </div>
      <div class="alert alert-warning" role="alert" *ngIf="!venue">
        <span>El recinto físico debe existir en la base de datos.</span>
      </div>
      <div class="selector-div-wrapper-sized">
        <div class="selector-div-wrapper align-items-center">
          <span>Cliente</span>
          <ng-multiselect-dropdown
            [placeholder]="'select client'"
            [settings]="dropdownSettings"
            [data]="authClients"
            [(ngModel)]="selectedClient">
          </ng-multiselect-dropdown>
        </div>
      </div>
      <div class="alert alert-warning" role="alert" *ngIf="!selectedClient.length">
        <span>El minisite se debe asociar a almenos un cliente.</span>
      </div>
      <div class="d-flex align-items-center mb-2 mt-2">
        <span>Version libreria: </span> <span class="ms-2 fw-bold">{{ libVersion }}</span>
      </div>
      <div class="table-container">
        <div>
          <span>Resumen</span>
          <table class="sb-table mb-3">
            <thead>
              <tr>
                <th>Logo</th>
                <th>Favicon</th>
                <th>Main title</th>
                <th>Subtitle</th>
                <th>Link</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <img [src]="logoPreview" />
                </td>
                <td>
                  <img [src]="faviconPreview" />
                </td>
                <td>
                  <span>{{ minisiteConfiguration.toolsConfig.titles.title }}</span>
                </td>
                <td>
                  <span>{{ minisiteConfiguration.toolsConfig.titles.subtitle }}</span>
                </td>
                <td class="text-center">
                  <span class="link-width">{{ minisiteConfiguration.toolsConfig.externalbtn.link }}</span>
                </td>
              </tr>
            </tbody>
          </table>
          <span>DVM</span>
          <table class="sb-table mb-3">
            <thead>
              <tr>
                <th>Venue ID</th>
                <th>Map ID</th>
                <th>Minimap</th>
                <th>Colores del mapa</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <span>{{ minisiteConfiguration.mapConfig.venue_id }}</span>
                </td>
                <td>
                  <span>{{ minisiteConfiguration.mapConfig.map_id }}</span>
                </td>
                <td>
                  <span *ngIf="minisiteConfiguration.toolsConfig.minimap?.enabled">
                    {{ minisiteConfiguration.toolsConfig.minimap.map_id }}
                  </span>
                </td>
                <td>
                  <span *ngIf="minisiteConfiguration.toolsConfig.colormap?.default"> Por defecto </span>
                  <span *ngIf="!minisiteConfiguration.toolsConfig.colormap?.default"> Personalizado </span>
                </td>
              </tr>
            </tbody>
          </table>

          <span *ngIf="minisiteConfiguration.mapConfig.workflow_id !== 6">Funcionalidades Generales</span>
          <table class="sb-table mb-3" *ngIf="minisiteConfiguration.mapConfig.workflow_id !== 6">
            <thead>
              <tr>
                <th *ngIf="minisiteConfiguration.toolsConfig.popups">Popups</th>
                <th *ngIf="minisiteConfiguration.toolsConfig.searcher">Buscador</th>
                <th *ngIf="minisiteConfiguration.toolsConfig.filters">Filtros</th>
                <th *ngIf="minisiteConfiguration.toolsConfig.neighbours">Neighbours</th>
                <th *ngIf="minisiteConfiguration.toolsConfig.translation">Traducciones</th>
                <th *ngIf="minisiteConfiguration.toolsConfig.multivenue">Configuraciones</th>
                <th *ngIf="minisiteConfiguration.toolsConfig.availability">Disponibilidad</th>
                <th *ngIf="minisiteConfiguration.toolsConfig.comparator">Comparador</th>
                <th *ngIf="minisiteConfiguration.toolsConfig.disclaimer">Disclaimer</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td *ngIf="minisiteConfiguration.toolsConfig.popups">
                  <i
                    [ngClass]="{
                      'fa fa-check': minisiteConfiguration.toolsConfig.popups.enabled
                    }"></i>
                </td>
                <td *ngIf="minisiteConfiguration.toolsConfig.searcher">
                  <i
                    [ngClass]="{
                      'fa fa-check': minisiteConfiguration.toolsConfig.searcher.enabled
                    }"></i>
                </td>
                <td *ngIf="minisiteConfiguration.toolsConfig.filters">
                  <i
                    [ngClass]="{
                      'fa fa-check': minisiteConfiguration.toolsConfig.filters?.enabled
                    }"></i>
                </td>
                <td *ngIf="minisiteConfiguration.toolsConfig.neighbours">
                  <i
                    [ngClass]="{
                      'fa fa-check': minisiteConfiguration.toolsConfig.neighbours?.enabled
                    }"></i>
                </td>
                <td *ngIf="minisiteConfiguration.toolsConfig.translation">
                  <i
                    [ngClass]="{
                      'fa fa-check': minisiteConfiguration.toolsConfig.translation?.enabled
                    }"></i>
                </td>
                <td *ngIf="minisiteConfiguration.toolsConfig.multivenue">
                  <i
                    [ngClass]="{
                      'fa fa-check': minisiteConfiguration.toolsConfig.multivenue?.enabled
                    }"></i>
                </td>
                <td *ngIf="minisiteConfiguration.toolsConfig.availability">
                  <i
                    [ngClass]="{
                      'fa fa-check': minisiteConfiguration.toolsConfig.availability?.unavailableNodesList
                    }"></i>
                </td>
                <td *ngIf="minisiteConfiguration.toolsConfig.comparator">
                  <i
                    [ngClass]="{
                      'fa fa-check': minisiteConfiguration.toolsConfig.comparator?.enabled
                    }"></i>
                </td>
                <td *ngIf="minisiteConfiguration.toolsConfig.disclaimer">
                  <i
                    [ngClass]="{
                      'fa fa-check': minisiteConfiguration.toolsConfig.disclaimer?.enabled
                    }"></i>
                </td>
              </tr>
            </tbody>
          </table>
          <div *ngIf="workflow.id !== 3 && workflow.id !== 4 && workflow.id !== 7">
            <span>Funcionalidades del Visor 360</span>
            <table class="sb-table mb-3">
              <thead>
                <tr>
                  <th>Panos version</th>
                  <th>Copy Link</th>
                  <th>Fullscreen</th>
                  <th>VR</th>
                  <th>Indoor</th>
                  <th>Navigation</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <span>{{ minisiteConfiguration.mapConfig.set_id }}</span>
                  </td>
                  <td>
                    <i
                      [ngClass]="{
                        'fa fa-check': minisiteConfiguration.toolsConfig.copylink?.enabled
                      }"></i>
                  </td>
                  <td>
                    <i
                      [ngClass]="{
                        'fa fa-check': minisiteConfiguration.toolsConfig.fullscreen?.enabled
                      }"></i>
                  </td>
                  <td>
                    <i
                      [ngClass]="{
                        'fa fa-check': minisiteConfiguration.toolsConfig.vr?.enabled
                      }"></i>
                  </td>
                  <td>
                    <i
                      [ngClass]="{
                        'fa fa-check': minisiteConfiguration.toolsConfig.indoor?.enabled
                      }"></i>
                  </td>
                  <td>
                    <i
                      [ngClass]="{
                        'fa fa-check': minisiteConfiguration.toolsConfig.navigation?.enabled
                      }"></i>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div
            *ngIf="minisiteConfiguration.toolsConfig.colormap && !minisiteConfiguration.toolsConfig.colormap.default">
            <span>Colores del mapa</span>
            <table class="sb-table mb-3">
              <thead>
                <tr>
                  <th colspan="2"><span>Sector</span></th>
                  <th colspan="2"><span>Asiento</span></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <span>Available</span>
                  </td>
                  <td>
                    <span>Selected</span>
                  </td>
                  <td>
                    <span>Available</span>
                  </td>
                  <td>
                    <span>Selected</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="color-bullets-list">
                      <span
                        title="normal"
                        class="color-bullet"
                        [ngStyle]="{
                          'background-color':
                            minisiteConfiguration.toolsConfig.colormap?.manual?.section?.available.normal.none.fillStyle
                        }"></span>
                      <span
                        title="hover"
                        class="color-bullet"
                        [ngStyle]="{
                          'background-color':
                            minisiteConfiguration.toolsConfig.colormap?.manual?.section?.available?.hover?.none
                              .fillStyle
                        }"></span>
                    </div>
                  </td>
                  <td>
                    <div class="color-bullets-list">
                      <span
                        title="normal"
                        class="color-bullet"
                        [ngStyle]="{
                          'background-color':
                            minisiteConfiguration.toolsConfig.colormap?.manual?.section?.selected?.normal.none.fillStyle
                        }"></span>
                      <span
                        title="hover"
                        class="color-bullet"
                        [ngStyle]="{
                          'background-color':
                            minisiteConfiguration.toolsConfig.colormap?.manual?.section?.selected?.hover.none.fillStyle
                        }"></span>
                    </div>
                  </td>
                  <td>
                    <div class="color-bullets-list">
                      <span
                        title="normal"
                        class="color-bullet"
                        [ngStyle]="{
                          'background-color':
                            minisiteConfiguration.toolsConfig.colormap?.manual?.seat?.available.normal.none.fillStyle
                        }"></span>
                      <span
                        title="hover"
                        class="color-bullet"
                        [ngStyle]="{
                          'background-color':
                            minisiteConfiguration.toolsConfig.colormap?.manual?.seat?.available.hover.none.fillStyle
                        }"></span>
                    </div>
                  </td>
                  <td>
                    <div class="color-bullets-list">
                      <span
                        title="normal"
                        class="color-bullet"
                        [ngStyle]="{
                          'background-color':
                            minisiteConfiguration.toolsConfig.colormap?.manual?.seat?.selected.normal.none.fillStyle
                        }"></span>
                      <span
                        title="hover"
                        class="color-bullet"
                        [ngStyle]="{
                          'background-color':
                            minisiteConfiguration.toolsConfig.colormap?.manual?.seat?.selected.hover.none.fillStyle
                        }"></span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div *ngIf="sitealreadyExists" class="confirmdelete">
        <div class="alert alert-danger" role="alert">
          <div>
            <b>
              <a target="_blank" [href]="sitealreadyExists.site.url" class="danger-link">
                <i class="fa fa-exclamation-triangle"></i>
                <i class="fa fa-external-link ms-2 me-2"></i>
                Ya existe un minisite con esa URL.
              </a>
            </b>
          </div>
          <div>
            ID: <b>{{ sitealreadyExists.site.id }}</b>
          </div>
          <div>
            Venue ID: <b>{{ sitealreadyExists.site.venue_code }}</b>
          </div>
          <div>
            Map ID: <b>{{ sitealreadyExists.site.map_id }}</b>
          </div>
          <div>
            Workflow: <b>{{ sitealreadyExists.site.workflow.name }}</b>
          </div>

          <button
            *ngIf="!checkdeleteconfirm; else confirmdelete"
            id="firsttrydelete"
            class="btn-secondary-action"
            (click)="checkdeleteconfirm = true">
            Eliminar este minisite
          </button>

          <ng-template #confirmdelete>
            <div *ngIf="checkdeleteconfirm">
              <hr />
              <div class="mb-2 text-center">
                <span>Esta acción no se podrá deshacer.</span><br />
                <span>¿ Eliminar antiguo minisite ?</span>
              </div>
              <div class="d-flex justify-content-center" *ngIf="!deletingSite">
                <button class="btn-secondary-action me-4" (click)="checkdeleteconfirm = false">No</button>
                <button class="btn-secondary-action" (click)="deletesite(sitealreadyExists.site.id)">Si</button>
              </div>
              <div class="d-flex align-items-center justify-content-center" *ngIf="deletingSite">
                <i class="fa fa-spinner fa-spin fa-2x fa-fw"></i>
                <span class="sr-only">Deleting...</span>
              </div>
            </div>
          </ng-template>
        </div>
      </div>

      <div class="btns-containers">
        <button class="cancel-btn" (click)="onDismiss('cancel')">Cancelar</button>
        <button
          class="confirm-btn"
          (click)="onConfirm(mode)"
          [disabled]="!client || sitealreadyExists || !selectedClient.length || !venue">
          Confirmar
        </button>
      </div>
    </div>
  </div>
  <button type="button" class="" (click)="onDismiss('cancel')" data-dismiss="modal">
    <span class="ti ti-close"></span>
  </button>
</div>
